import styled from 'styled-components';
import {Button} from 'antd';

const StyledPrimaryTextButton = styled(Button)`
  color: ${props => props.theme.colors.primary_6};
  padding: 0;

  &:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: transparent;
    color: ${props => props.theme.colors.primary_7};
  }

  &:not(:disabled):not(.ant-btn-disabled):active {
    color: ${props => props.theme.colors.primary_8};
  }
`;

export {
  StyledPrimaryTextButton
};
